// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"nav_navWrapper__3R9dH","logo":"nav_logo__1bE1L","menu":"nav_menu__VArbq","nav":"nav_nav__29uK4","container":"nav_container__z7DYk"};